import React from 'react';
import {useTranslation} from 'react-i18next';
import {QuestionMarkCircleIcon} from '@heroicons/react/24/outline';
import HeroCard from './HeroCard';
import HeroCardGroup from './HeroCardGroup';
import HandshakeIcon from './icons/HandshakeIcon';
import SeedlingIcon from './icons/SeedlingIcon';

export default function MicrositeHeroCards() {
  const {t} = useTranslation();

  return (
    <HeroCardGroup>
      <HeroCard
        icon={HandshakeIcon}
        title={t('microsite.project.hero_cards.collaborate.title')}
        body={t('microsite.project.hero_cards.collaborate.body')}
      />
      <HeroCard
        icon={QuestionMarkCircleIcon}
        title={t('microsite.project.hero_cards.fit.title')}
        body={t('microsite.project.hero_cards.fit.body')}
      />
      <HeroCard
        icon={SeedlingIcon}
        title={t('microsite.project.hero_cards.benefit.title')}
        body={t('microsite.project.hero_cards.benefit.body')}
      />
    </HeroCardGroup>
  );
}
